import { Auth } from 'aws-amplify';

export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

export const amplifyConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  // aws_cognito_identity_pool_id:
  //   process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
};

export const amplifyConfig2 = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  aws_appsync_region: process.env.REACT_APP_AWS_APPSYNC_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_AWS_APPSYNC_AUTHENTICATION_TYPE,
  aws_appsync_apiKey: process.env.REACT_APP_AWS_APPSYNC_API_KEY,
  resortCatalogApiKey: process.env.REACT_APP_AWS_APPSYNC_RESORT_CATALOG_API_KEY,
  // For some reason amplify stopped sending the id token so this workaround is needed
  // Lifted from here: https://github.com/aws-amplify/amplify-js/issues/4751
  // graphql_headers: async () => ({
  //   'Authorization': (await Auth.currentSession()).getIdToken().getJwtToken()
  // })
  // I'm not happy that this errors when the user is not logged in
  graphql_headers: async () => ((await Auth.currentUserInfo()) ? {
    'Authorization': (await Auth.currentSession()).getIdToken().getJwtToken()
  } : '')
};

export const intercomConfig = {
  app_id: process.env.REACT_APP_INTERCOM_APP_ID
};

export const stripeConfig = {
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  publishableKeyTest: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST || '',
  publishableKeyLive: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_LIVE || ''
};
